export const NETWORK = "mainnet"
export const ALCHEMY_KEY = "-Vh7Rg3A_k87l28g1kyRdMkbyGsWJZRE"
export const CONTRACT_ADDRESS ="0x5E8A578B58582a1CB9D447862859f5A0c303E675"